import { Theme } from '@mui/material';

/**
 * 📱 Detect Mobile Screen (COMMON HELPER)
 * Use this anywhere instead of useMediaQuery
 */
export const isMobileScreen = (theme: Theme) => {
  if (typeof window === 'undefined') return false;
  return window.innerWidth <= theme.breakpoints.values.sm;
};

/**
 * 📱 Optional: Tablet detection (if needed later)
 */
export const isTabletScreen = (theme: Theme) => {
  if (typeof window === 'undefined') return false;
  return (
    window.innerWidth > theme.breakpoints.values.sm &&
    window.innerWidth <= theme.breakpoints.values.md
  );
};

/**
 * 🎨 RESPONSIVE STYLES
 */
export const getResponsiveStyles = (theme: Theme) => ({
  // 🔁 Flex → Row (Laptop) → Column (Mobile)
  rowToColumn: {
    display: 'flex',
    gap: '12px',
    width: '100%',
    flexWrap: 'wrap',

    flexDirection: 'row',

    [theme.breakpoints.down('md')]: {
      flexDirection: 'row',
      flexWrap: 'wrap'
    },

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column'
    }
  },

  // 🔥 Auto Grid Layout
  gridAutoFit: {
    display: 'grid',
    gap: '12px',

    gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',

    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))'
    },

    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr'
    }
  },

  // 📦 Card wrapper fix
  cardWrapper: {
    width: '100%',
    minWidth: 0
  },

  // 🔥 ACTION BUTTON GROUP
  actionButtons: {
    display: 'flex',
    gap: '12px',
    alignItems: 'center',
    flexWrap: 'wrap',

    [theme.breakpoints.down('md')]: {
      justifyContent: 'flex-end'
    },

    [theme.breakpoints.down('sm')]: {
      justifyContent: 'space-between',
      width: '100%'
    }
  },

  // 🔥 ICON ONLY BUTTON (Mobile)
  iconButtonOnly: {
    minWidth: 'auto',
    padding: '6px 16px',

    [theme.breakpoints.down('sm')]: {
      minWidth: '40px',
      padding: '8px',
      '& .MuiButton-startIcon': {
        margin: 0
      }
    }
  },

  // 🔥 Hide text on mobile
  hideTextMobile: {
    display: 'block',

    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  },

  // 🔥 FILTER SECTION
  filtersWrapper: {
    display: 'flex',
    gap: '16px',
    width: '100%',

    [theme.breakpoints.down('md')]: {
      flexWrap: 'wrap'
    },

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column'
    }
  },

  // 🔥 DATAGRID FIX
  dataGrid: {
    width: '100%',

    [theme.breakpoints.down('sm')]: {
      '& .MuiDataGrid-root': {
        overflowX: 'auto'
      },
      '& .MuiDataGrid-cell': {
        whiteSpace: 'nowrap'
      }
    }
  },


  // ================= mobile header and add subcriber button

mobileHeader: {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  gap: '10px',
  padding: '6px 12px',

  [theme.breakpoints.up('sm')]: {
    display: 'none'
  }
},

mobileTitle: {
  fontSize: '15px',
  fontWeight: 600,
  whiteSpace: 'nowrap',
  color: theme.colors.alpha.trueWhite[100]
},

mobileHeaderActions: {
  display: 'flex',
  alignItems: 'center',
  gap: '8px'
},

mobileAddButton: {
  fontSize: '10px',
  padding: '4px 10px',
  height: '30px',
  minWidth: 'auto',

  backgroundColor: theme.colors.primary.main,
  color: theme.colors.alpha.trueWhite[100],

  '&:hover': {
    backgroundColor: theme.colors.primary.dark
  }
},

// ================= FILTER BAR =================

mobileFilterBar: {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: '8px',
  marginTop: '8px',
  padding: '0 8px',

  [theme.breakpoints.up('sm')]: {
    display: 'none'
  }
},

mobileIconButton: {
  minWidth: '36px',
  width: '36px',
  height: '36px',
  padding: '6px',
  color: theme.colors.alpha.trueWhite[100]
},

mobileSmallIconButton: {
  minWidth: '32px',
  width: '32px',
  height: '32px',
  padding: '4px',
  color: theme.colors.alpha.trueWhite[100]
},

// ================= CARD LIST =================

mobileCardContainer: {
  maxHeight: '75vh',
  overflowY: 'auto',
  paddingRight: '8px'
},

mobileCard: {
  borderRadius: theme.general.borderRadiusLg,
  padding: '14px',
  marginBottom: '12px',

  background: theme.colors.gradients.blue3,
  color: theme.colors.alpha.trueWhite[100],

  boxShadow: theme.colors.shadows.primary,
  transition: '0.3s'
},

mobileCardHeader: {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center'
},

mobileCardTitle: {
  fontWeight: 600,
  color: theme.colors.alpha.trueWhite[100]
},

mobileCardSubText: {
  fontSize: '12px',
  color: theme.colors.alpha.trueWhite[70]
},

mobileCardText: {
  fontSize: '13px',
  color: theme.colors.alpha.trueWhite[100]
},

mobileCardStatus: {
  marginTop: '8px',
  display: 'inline-block',
  padding: '3px 10px',
  borderRadius: '6px',
  fontSize: '12px',
  fontWeight: 600
},

mobileCardActions: {
  marginTop: '12px',
  display: 'flex',
  justifyContent: 'space-between',
  flexWrap: 'wrap',
  gap: '6px'
},

mobileLoadMore: {
  textAlign: 'center',
  marginTop: '12px'
},

//====================== subcriber index mobile style end here===================

//====== ott subcriber hardware 

mobileDashboardHeader: {
  marginBottom: '16px'
},

mobileHeaderTop: {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '8px'
},

mobileHeaderLeft: {
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  flex: 1,
  minWidth: 0
},

mobileHeaderTitle: {
  fontSize: '16px',
  fontWeight: 600,
  color: theme.colors.alpha.trueWhite[100],
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis'
},

mobileWalletCard: {
  marginTop: '10px',
  padding: '10px 12px',
  borderRadius: theme.general.borderRadius,

  border: `2px solid ${theme.colors.primary.main}`,
  backgroundColor: theme.colors.alpha.white[5],

  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between'
},

mobileWalletLeft: {
  display: 'flex',
  alignItems: 'center',
  gap: '10px'
},

mobileTabsWrapper: {
  display: 'flex',
  gap: '8px',
  overflowX: 'auto',
  padding: '8px',

  '&::-webkit-scrollbar': {
    display: 'none'
  }
},

mobileTabItem: {
  minWidth: '140px',
  padding: '8px 10px',
  borderRadius: '12px',
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  cursor: 'pointer',
  flexShrink: 0
},

mobileTabText: {
  fontSize: '12px',
  fontWeight: 600
},

//======================mobile top header
mobileTopHeader: {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  padding: '6px 10px',
  gap: '8px',

  [theme.breakpoints.up('sm')]: {
    display: 'none'
  }
},

mobileTopHeaderLeft: {
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  flex: 1
},

mobileTopHeaderRight: {
  display: 'flex',
  alignItems: 'center',
  gap: '6px'
},

mobileWalletBox: {
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  padding: '6px 10px',
  borderRadius: '10px',
  border: `1px solid ${theme.colors.primary.main}`,
  backgroundColor: theme.colors.alpha.white[10],
  fontSize: '14px',
  fontWeight: 600
},

// 🔥 Operator Screen Mobile Fix

operatorSearchWrapper: {
  display: 'flex',
  alignItems: 'center',
  marginBottom: '12px',
  width: '25%',
  padding: '0 5px',

  [theme.breakpoints.down('sm')]: {
    width: '100%',
    padding: '0'
  }
},

operatorSearchField: {
  marginLeft: '16px',

  [theme.breakpoints.down('sm')]: {
    marginLeft: '0'
  }
},

operatorGridWrapper: {
  height: 'calc(100vh - 250px)',
  padding: '15px',

  [theme.breakpoints.down('sm')]: {
    padding: '8px',
    height: 'auto'
  }
},

operatorDataGrid: {
  width: '100%',

  [theme.breakpoints.down('sm')]: {
    '& .MuiDataGrid-root': {
      overflowX: 'auto'
    },
    '& .MuiDataGrid-cell': {
      whiteSpace: 'nowrap'
    },
    '& .MuiDataGrid-columnHeaders': {
      fontSize: '12px'
    }
  }
},


mobileHeaderRow: {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '10px',
  marginBottom: '10px',

  [theme.breakpoints.up('sm')]: {
    display: 'none'
  }
},

mobileSearchRow: {
  marginBottom: '12px',

  [theme.breakpoints.up('sm')]: {
    display: 'none'
  }
}


  
});


